export const SUMMARY = [
  {
    title: "Coins",
    field: "coinsBalance",
  },
  {
    title: "Tickets",
    field: "ticketsBalance",
  },
  {
    title: "Referrals",
    field: "referrals",
  },
  {
    title: "Ref Coins",
    field: "referralCoins",
  },
  {
    title: "IAP ($)",
    field: "iapTotal",
  },
  {
    title: "XP Balance",
    field: "xpDetails.totalRewards",
  },
  {
    title: "XP level",
    field: "xpDetails.level.name",
  },
  {
    title: "Division League",
    field: "divisionLeague.currentDivisionName",
  },
  {
    title: "League ID",
    field: "divisionLeague.currentLeagueId",
  },
  {
    title: "GP Spent",
    field: "gameProviderEntryAmount",
  },
  {
    title: "GP Winnings",
    field: "gameProviderEntryPrize",
  },
  {
    title: "GP Profit",
    field: "gameProviderProfit",
  },
  {
    title: "Cards Count",
    field: "cardsCount",
  },
];

export const CHALLENGE_TYPE = {
  CLUB: 0,
  PUBLIC: 1,
};

export const COMPONENT_TYPES = {
  minigame: { value: 0, label: "Mini Game" },
  adbanner: { value: 1, label: "Banner Ad" },
  ultimatefan: { value: 2, label: "Ultimate Fan" },
  inapplink: { value: 3, label: "In-App Link" },
};
